import { JSONSchemaType } from 'ajv'

export interface IUserProfileFormData {
  id: string
  userId: string
  profileId: string
}

const UserProfileSchema: JSONSchemaType<IUserProfileFormData> = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    userId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    profileId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
  },
  required: ['profileId', 'userId'],
  additionalProperties: false,
}

export default UserProfileSchema
